import { apiClient, ApiClientResponse } from '../api/ApiClient';

/**
 * 住所検索API
 * @param param
 *   zipcode 郵便番号
 * @returns 住所
 */
const getAddress = async (param: {
  zipcode: string;
}): Promise<
  ApiClientResponse<
    {
      code: number;
      data: {
        pref: string;
        address: string;
        city: string;
        town: string;
        fullAddress: string;
      };
    }[]
  >
> => {
  return await apiClient.get(`https://api.zipaddress.net/?zipcode=${param.zipcode}`);
};

export default {
  getAddress,
};
